// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OREv","image":"Header_image__2LrXd","name":"Header_name__-cvFC","info":"Header_info__1c7qm","infoRow":"Header_infoRow__3HbAa"};